import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=13c9fb1e&scoped=true"
import script from "./Register.vue?vue&type=script&setup=true&lang=js"
export * from "./Register.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=13c9fb1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9fb1e",
  null
  
)

export default component.exports